import { useContext } from 'react'

import { Box } from '@fairfashion/design-system'

import { TraceabilityTree } from '../../../../components/TraceabilityTree'
import { useItemTree } from '../../../../components/TraceabilityTree/hooks/useItemTree'
import { ProductDetailsContext } from '../../product-details.context'

import { ProductItemTraceabilityProps } from './product-item-traceability.types'

export const ProductItemTraceability = ({
  itemId,
}: ProductItemTraceabilityProps) => {
  const { itemTraceability } = useContext(ProductDetailsContext)

  const traceabilityProps = useItemTree({
    traceability: itemTraceability,
  })

  return (
    <Box width="100%" height="100%">
      {itemId && (
        <TraceabilityTree
          showDirectionSwitch={false}
          showMinimap={false}
          initialDirection="LR"
          showExpand
          {...traceabilityProps}
        />
      )}
    </Box>
  )
}
